'use strict';

const containers = {};

const container = {
  setStateFun(fun, state) {
    return Object.assign(state, fun.call(this, state));
  },

  setStateProp(props, state) {
    return Object.assign(state, props);
  },

  getContainer(name) {
    return containers[name];
  },

  getState(name) {
    return containers[name] ? containers[name].state : undefined;
  },

  setState(props, name) {
    const newState =
      typeof props === 'function'
        ? container.setStateFun(props, container.getState(name))
        : container.setStateProp(props, container.getState(name));

    container.getContainer(name).state = newState;
  },

  injectContainer(name, s = {}, obj = null) {
    containers[name] = { state: s };
    if (obj) {
      obj.container = containers[name];
    }
  },

  connectState(containerName, base) {
    base.prototype.getState = name => {
      return name
        ? container.getState(name)
        : container.getState(containerName);
    };

    base.prototype.setState = (props, name) => {
      name
        ? container.setState(props, name)
        : container.setState(props, containerName);
    };
  },
};

module.exports = container;



// WEBPACK FOOTER //
// ./modules/ugc_photos/frontend/container.js